import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "ic_share",
  "use": "ic_share-usage",
  "viewBox": "0 0 17 19",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 17 19\" id=\"ic_share\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M-2 0h20v20H-2z\" /><g stroke=\"#42B4E6\"><path d=\"M16.219 4.129a2.629 2.629 0 1 1-5.258 0 2.629 2.629 0 0 1 5.258 0zM16.219 15.871a2.629 2.629 0 1 1-5.258 0 2.629 2.629 0 0 1 5.258 0z\" /><path d=\"M11.298 5.415L5.419 8.714l-.06-.108a2.62 2.62 0 0 0-2.23-1.235 2.62 2.62 0 0 0-1.859.77A2.62 2.62 0 0 0 .5 9.999c0 .727.295 1.384.77 1.859a2.62 2.62 0 0 0 1.859.77A2.62 2.62 0 0 0 5.36 11.39l.06-.106 5.878 3.299\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol